// Realms (境界) related helpers
const REALM_NAMES = ['炼气', '筑基', '金丹', '元婴', '化神', '渡劫', '真仙'];
const SUBSTAGE_NAMES = ['1层', '2层', '3层', '4层', '5层', '6层', '7层', '8层', '9层', '10层'];
const PERIOD_NAMES = ['前期', '前期', '前期', '中期', '中期', '中期', '后期', '后期', '后期', '巅峰'];
const BASE_ATTRIBUTES = {
  qi: 100,
  attack: 10,
  defense: 5,
  mana: 50,
  divineSenseStrength: 100
};

function calculateRealmMultiplier(realm) {
  return Math.pow(2, realm); // K = 2^realm
}

function calculateSubstageMultiplier(substage) {
  const multipliers = [0.8, 0.85, 0.9, 1.0, 1.05, 1.1, 1.2, 1.25, 1.3, 1.5];
  return multipliers[substage] || 1.0;
}

function calculateAttributes(realm, substage) {
  const K = calculateRealmMultiplier(realm);
  const h = calculateSubstageMultiplier(substage);
  const attributes = {};
  for (const [key, base] of Object.entries(BASE_ATTRIBUTES)) {
    attributes[key] = Math.floor(base * K * h);
  }
  return attributes;
}

function updatePlayerAttributes(state) {
  const attrs = calculateAttributes(state.realm, state.substage);
  state.maxQi = attrs.qi;
  state.originalMaxQi = attrs.qi; // 更新原始上限跟随境界提升
  state.qi = Math.min(state.qi, state.maxQi); // 保持当前气血不超过上限
  state.attack = attrs.attack;
  state.defense = attrs.defense;
  state.mana = attrs.mana;
  state.divineSenseStrength = attrs.divineSenseStrength;
}

function xpToLevel(level) {
  // level = realm * 10 + substage, 从0开始
  let base = 100 * (level + 1) * (level + 1); // 调整为更大的升级需求
  if ((level % 3) === 2) {
    base *= 2; // 小阶段跃变时所需修为幅度变高
  }
  return base;
}

function gainXp(state, amount) {
  state.xp += amount;
  const msgs = [`获得 ${amount} 修为。`];
  let currentLevel = state.realm * 10 + state.substage;
  while (state.xp >= xpToLevel(currentLevel)) {
    state.xp -= xpToLevel(currentLevel);
    // 升级到下一个小阶段
    state.substage += 1;
    if (state.substage >= 10) {
      // 小阶段满了，进入下一个大境界
      state.substage = 0;
      state.realm += 1;
      if (state.realm >= REALM_NAMES.length) {
        // 达到最高境界
        state.realm = REALM_NAMES.length - 1;
        state.substage = 9;
        const realmName = REALM_NAMES[state.realm] || '未知';
        const substageName = SUBSTAGE_NAMES[state.substage] || '未知';
        const periodName = PERIOD_NAMES[state.substage] || '未知';
        msgs.push(`恭喜！已达到最高境界 ${realmName}${substageName}（${periodName}）！`);
        break;
      }
    }
    // 更新currentLevel
    currentLevel = state.realm * 10 + state.substage;
    // 更新属性
    updatePlayerAttributes(state);
    const realmName = REALM_NAMES[state.realm] || '未知';
    const substageName = SUBSTAGE_NAMES[state.substage] || '未知';
    const periodName = PERIOD_NAMES[state.substage] || '未知';
    msgs.push(`恭喜！突破至 ${realmName}${substageName}（${periodName}），属性大幅提升！`);
    msgs.push(`气血上限：${state.maxQi}，攻击：${state.attack}，防御：${state.defense}，灵力：${state.mana}，神识强度：${state.divineSenseStrength}`);
  }
  return msgs;
}

export { xpToLevel, gainXp };
